"use client";

import { Urls, getUrl } from "@/lib/constants/urls";
import { LanguageParams } from "@/lib/types/PageProps";
import LinkButton from "../Link";
import { GoogleTagManagerEvents } from "@/lib/utils/googleTagEvents";
import { useTranslation } from "@/lib/i18n/client";

export default function FAQContactUsButtonLink({ lang }: Readonly<LanguageParams>) {
    const { t } = useTranslation(lang, "faqs");
    return (
        <LinkButton
            href={getUrl(Urls.contactUs.index, lang)}
            variant="transparent"
            size="lg"
            fontSize="base"
            className="w-48 font-bold"
            onClick={() => GoogleTagManagerEvents.clickFAQorBecomeHostorContact(lang, "contact")}
        >
            {t("contact-us")}
        </LinkButton>
    );
}
